import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './wrike-folder.types';

export const wrikeFolderSelectors = {
  ...generateResourceSelectors<types.IWrikeFolder>((state) => state.resource.wrikeFolder),
};
